__turbopack_context__.v({
  "section": "SectionWrapper-module-scss-module__5yIgma__section",
});
